import React from 'react';
import logo from './logo.svg';
import {BrowserRouter as Router, Route} from 'react-router-dom';
// import {spring, AnimatedSwitch } from 'react-router-transition';
import Routes from './Routes';
import './App.css';
import Master from './utils/Master';

function App() {
  return (
    <Router>
      {/* <Switch> */}
      {/* <AnimatedSwitch
      atEnter={{ opacity: 0 }}
      atLeave={{ opacity: 0 }}
      atActive={{ opacity: 1 }}

      // atEnter={bounceTransition.atEnter}
      // atLeave={bounceTransition.atLeave}
      // atActive={bounceTransition.atActive}
      mapStyles={mapStyles}

      className="switch-wrapper"
      > */}
        {Routes.map(route => (
          <Route exact path = {route.path} 
          render= {(props) => {return (<Master bodyEnglish={route.componentEnglish(props)} bodyIndonesian={route.componentIndonesian(props)} path={route.path}/>)}}
          />
        ))
        }
        {/* </AnimatedSwitch> */}
    </Router> 
  );
}

export default App;
